import { render, staticRenderFns } from "./emptyInvoice.vue?vue&type=template&id=5d3cf590"
import script from "./emptyInvoice.vue?vue&type=script&lang=js"
export * from "./emptyInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports